<template>
	<ul class="consequence-list">
		<li v-for="item in items" :key="item" class="consequence-list__item">
			<img class="consequence-list__icon" :src="checkmark" alt="" width="20" height="20" />
			<Text font="--text-14-20-med" color="--text-dark-primary">{{ item }}</Text>
		</li>
	</ul>
</template>

<script setup lang="ts">
// "✓ Your next 3-month supply won't ship …" — what happens after a commitment exit
// (Figma 7415:18138, 7415:18411): 20px green checks, 8 in from the edge, the text 12 beside them.
import { Text } from '@simple-life-app/growth-ui-kova'
import checkmark from '@/assets/icons/checkmark.svg'

defineProps<{
	items: string[]
}>()
</script>

<style scoped>
.consequence-list {
	display: flex;
	flex-direction: column;
	gap: var(--size-12);
	width: 100%;
	margin: 0;
	padding: 0;
	list-style: none;
}

.consequence-list__item {
	display: flex;
	align-items: flex-start;
	gap: var(--size-12);
	padding: 0 var(--size-8);
}

/* The asset is drawn upside down; the frame flips it (icon-checkmark, -scale-y-100). */
.consequence-list__icon {
	flex-shrink: 0;
	transform: scaleY(-1);
}
</style>
